import Link from '@mui/material/Link';
import {
    useLocation,
    Link as RouterLink
}           from 'react-router-dom';

function capitalize(s: string) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}

const NavBar = (
    props: {nodesMap?: Map<string, string>}
) => {
    const loc = useLocation();
    const nodes = loc.pathname.split('/').filter(val=>val);
    return (
        <>
            {nodes.map((node, idx) => (
                <Link
                    key={idx}
                    underline='none'
                    color={idx === nodes.length - 1 ? 'text.primary' : 'secondary'}
                    to={'/' + nodes.slice(0, idx + 1).join('/')}
                    component={RouterLink as any}
                >
                    {idx !==0 && ' '}{
                        capitalize(props.nodesMap?.get(node) || node)
                    } {idx !== nodes.length - 1 && '/'}
                </Link>
            ))}
        </>
    );
};

export default NavBar;